import React from "react";
import { MRT_ColumnDef } from "material-react-table";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import { EMPTY_CELL_VALUE } from "consts";
import { isNullOrUndefined, getDateFormatset } from "utils";
import { KPISummaryItem } from "api";

const defaultCell = ({ cell }: any) => {
  const value = cell.getValue() as string;

  if (isNullOrUndefined(value)) {
    return EMPTY_CELL_VALUE;
  }

  return (
    <Box>{value}</Box>
  );
};

const numberCell = ({ cell }: any) => {
  const value = cell.getValue() as number;

  if (isNullOrUndefined(value)) {
    return EMPTY_CELL_VALUE;
  }

  return (
    <Box>{value}</Box>
  );
};

const dateCell = ({ cell }: any) => {
  const value = cell.getValue() as string;

  if (isNullOrUndefined(value)) {
    return EMPTY_CELL_VALUE;
  }

  const formattedDate = dayjs(value).format(getDateFormatset('-'));
  return (
    <Box>{formattedDate}</Box>
  );
};

export const CustomKpisSummaryTableColumns: MRT_ColumnDef<KPISummaryItem>[] = [
  {
    accessorKey: "siteName",
    header: "Site Name",
    Cell: defaultCell,
  },
  {
    accessorKey: "businessUnit",
    header: "Business Unit",
    Cell: defaultCell,
  },
  {
    accessorKey: "category",
    header: "Category",
    Cell: defaultCell,
  },
  {
    accessorKey: "kpiName",
    header: "KPI",
    Cell: defaultCell,
  },
  {
    accessorKey: "kpiType",
    header: "KPI - Type",
    Cell: defaultCell,
  },
  {
    accessorKey: "kpiSubType",
    header: "KPI - Subtype",
    Cell: defaultCell
  },
  {
    accessorKey: "kpiDescription",
    header: "Description",
    Cell: defaultCell
  },
  {
    accessorKey: "treatmentMethod",
    header: "Treatment Method",
    Cell: defaultCell,
  },
  {
    accessorKey: "kpiClass",
    header: "Class",
    Cell: defaultCell,
  },
  {
    accessorKey: "startDate",
    header: "Start Date",
    Cell: dateCell,
  },
  {
    accessorKey: "endDate",
    header: "End Date",
    Cell: dateCell,
  },
  {
    accessorKey: "value",
    header: "Value",
    Cell: numberCell,
  },
  {
    accessorKey: "unit",
    header: "Unit",
    Cell: defaultCell,
  },
  {
    accessorKey: "defaultUnitValue",
    header: "Default Value",
    Cell: numberCell,
  },
  {
    accessorKey: "defaultUnit",
    header: "Default Unit",
    Cell: defaultCell,
  },
  {
    accessorKey: "cost",
    header: "Cost",
    Cell: numberCell,
  },
  {
    accessorKey: "currency",
    header: "Currency",
    Cell: defaultCell,
  },
];